import { getPriceDictionary, addPriceDictionary, updatePriceDictionary, deletePriceDictionary, getPriceDictionaryKeys, getBeefPriceDataOpinionList } from '@/api/price'

const notes = {
  state: {
    total: 0,
    rows: [],
    row: {}
  },
  mutations: {
    SET_TOTAL: (state, total) => {
      state.total = total
    },
    SET_ROWS: (state, rows) => {
      state.rows = rows
    },
    SET_ROW: (state, row) => {
      state.row = row
    }
  },
  actions: {
    // 查询行情字段
    GetPriceDictionary({ commit }, params) {
      return new Promise((resolve, reject) => {
        getPriceDictionary(params).then(response => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 添加行情字段
    AddPriceDictionary({ commit }, params) {
      return new Promise((resolve, reject) => {
        addPriceDictionary(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 修改行情字段
    UpdatePriceDictionary({ commit }, params) {
      return new Promise((resolve, reject) => {
        updatePriceDictionary(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 删除行情字段
    DeletePriceDictionary({ commit }, params) {
      return new Promise((resolve, reject) => {
        deletePriceDictionary(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询行情字段
    GetPriceDictionaryKeys({ commit }, params) {
      return new Promise((resolve, reject) => {
        getPriceDictionaryKeys(params).then((response) => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetBeefPriceDataOpinionList({ commit }, params) {
      return new Promise((resolve, reject) => {
        getBeefPriceDataOpinionList(params).then(response => {
          commit('SET_TOTAL', response.Data.Total)
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default notes



// WEBPACK FOOTER //
// ./src/store/modules/price.js